import axios from 'axios'

export default {
    getAllowedDomains(): Promise<string[]> {
        let version = (new Date()).getTime();
        let publicPath = process.env.NODE_ENV === 'production' ? '/cubelook/' : '/';

        return axios.get(`${publicPath}assets/allowed-domains.json?v=${version}`).then(res => {
            return res.data.allowedDomains;
        });
    }
}